// extracted by mini-css-extract-plugin
module.exports = {"claim":"Claim_claim__Qqmz_"};